import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AvailablePermission } from '@backoffice/shared/bo/util-permissions';
import {
  PersonManagementDomainModule,
  RoleListFacade,
} from '@clean-code/backoffice/person-management/domain';
import { Role } from '@clean-code/models';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import { DataTableBaseComponent } from '@clean-code/shared/components/ui-data-table';
import { UiMatTableModule } from '@clean-code/shared/components/ui-mat-table';
import { PageContainerModule } from '@clean-code/shared/components/ui-page-container';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxPermissionsModule } from 'ngx-permissions';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cc-role-management-list',
  templateUrl: './role-management-list.component.html',
  styleUrls: ['./role-management-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    UiMatTableModule,
    TranslocoModule,
    PageContainerModule,
    NgxPermissionsModule,
    PersonManagementDomainModule,
    ActionButtonModule,
  ],
})
export class RoleManagementListComponent extends DataTableBaseComponent<Role> {
  public permissions = AvailablePermission;
  public override navigateUrl = '/settings/roles/backoffice';

  constructor() {
    const facade = inject(RoleListFacade);
    super(facade);
    this.addFilterParams = [
      {
        key: 'tenant',
        conditions: `{ tenant: { eq:  "backoffice"} }`,
      },
    ];
  }
}
